import(/* webpackMode: "eager" */ "/codebuild/output/src820538367/src/SkillBridger/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src820538367/src/SkillBridger/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src820538367/src/SkillBridger/src/components/AppShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthWrapper"] */ "/codebuild/output/src820538367/src/SkillBridger/src/components/AuthWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/codebuild/output/src820538367/src/SkillBridger/src/contexts/AuthContext.tsx");
